import { api } from "../../api";
import { CreateQueryParams } from "../../functions/ResourceFunctions";

const permission = () => {
  const identityService = process.env.REACT_APP_BACKEND_IDENTITY_URL;
  const ind_api = api(identityService);

  return {
    GetAllAppPermissions: function () {
      return ind_api.get(`/Permission`);
    },
    GetAllUsersPermissions: function (data) {
      const { filter, sort, pageSize, currentPage, searchText } = data;
      return ind_api.get(
        `/UserPermission?PageSize=${pageSize}&CurrentPage=${currentPage}&FilterBy=${filter}&SortBy=${sort}&SearchText=${searchText}`
      );
    },
    GetCurrentUserPermissions: function () {
      return ind_api.get(`/UserPermission/details`);
    },
    GetUserPermissionById: function (userId) {
      return ind_api.get(`/UserPermission/${userId}`);
    },
    UpdateStaffPermissions: function (data) {
      return ind_api.post(`/UserPermission/update`, data);
    },
    GetGroupPermissions: function (payload) {
      return ind_api.get(`/Group${CreateQueryParams(payload)}`);
    },
    GetGroupPermission: function (permId) {
      return ind_api.get(`/Group/${permId}`);
    },
    CreateGroupPermission: function (data) {
      return ind_api.post(`/Group/add`, data);
    },
    UpdateGroupPermission: function (data) {
      return ind_api.post(`/Group/update`, data);
    },
    DeleteGroupPermission: function (data) {
      return ind_api.post(`/Group/delete`, data);
    },
    AddPermissionToGroup: function (data) {
      return ind_api.post(`/Group/addPermissionToGroup`, data);
    },
    RemovePermissionFromGroup: function (data) {
      return ind_api.post(`/Group/removePermissionFromGroup`, data);
    },
  };
};

export const PermissionService = {
  permission,
};
